import type { ReactNode } from 'react';

import { useTranslation } from '@mint-lib/i18n';
import { Information } from '@mint-lib/icons';
import { typographyVariants } from '@mint-lib/tw-components';

import type { GlossaryType } from '../../api/types.js';
import { Tooltip } from '../atoms/Tooltip.jsx';

export const GlossaryOptionLabel = ({
  glossaryType,
  label,
  icon,
  readOnly,
}: {
  glossaryType: GlossaryType;
  label: string;
  icon: ReactNode;
  readOnly?: boolean;
}) => {
  const { t } = useTranslation('@myn/import-hub');

  return (
    <div className="flex flex-row gap-2">
      {icon}
      <span
        className={typographyVariants({
          variant: 'bodyShort01',
          color: readOnly ? 'disabled' : 'primary',
        })}
      >
        {label}
      </span>
      {readOnly ? (
        <Tooltip
          description={t('This {{glossaryType}} has already been selected', {
            glossaryType,
          })}
        >
          <div>
            <Information className="fill-text-disabled" />
          </div>
        </Tooltip>
      ) : null}
    </div>
  );
};
